<template>
  <div class="partner-page">
    <section class="partner-section">
      <h2 class="partner-section__title">{{ $t('partner.title') }}</h2>
      <p class="partner-section__subtitle">{{ $t('partner.subtitle') }}</p>
      <article class="partner-card">
        <img class="partner-card__img" :src="contentImg" :alt="$t('partner.title')">
      </article>
    </section>
  </div>
</template>

<script>
import contentImg from '@/assets/内容1.png'

export default {
  name: 'PartnerPage',
  data() {
    return {
      contentImg
    }
  }
}
</script>

<style scoped>
.partner-page {
  width: 100%;
  padding-bottom: 24px;
}

.partner-section__title {
  margin: 0;
  color: #1f2d3d;
  font-size: clamp(24px, 3.2vw, 32px);
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  letter-spacing: -0.02em;
}

.partner-section__subtitle {
  max-width: 760px;
  margin: 12px auto 0;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.7;
  text-align: center;
}

.partner-card {
  margin-top: 22px;
  padding: 20px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid rgba(148, 163, 184, 0.16);
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.06);
}

.partner-card__img {
  display: block;
  width: 80%;
  max-width: 80%;
  height: auto;
  margin: 0 auto;
  object-fit: contain;
  border-radius: 12px;
}

@media (max-width: 640px) {
  .partner-card {
    padding: 16px;
  }
}
</style>
